import React from "react";
import { Navigate } from "react-router-dom";
import { auth } from "../lib/api";

export default function RequireAdmin({ children }) {
  if (!auth.getToken()) return <Navigate to="/admin/login" replace />;
  return children;
}
